import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';

import OptionItem from './OptionItem';

import '../CommonGroupedDropdown.scss';

function DropdownMenu({
  listboxId,
  isTop,
  isBorder,
  hasOptions,
  filteredGroups,
  searchQuery,
  withIcons,
  isEmojiIcons,
  highlightedOption,
  onSelectOption,
  menuRef,
}) {
  const { t } = useTranslation();

  return (
    <div
      ref={menuRef}
      id={listboxId}
      role='listbox'
      aria-label={t('chooseAnOption')}
      tabIndex={-1}
      className={clsx(
        'common-grouped-dropdown_menu',
        isTop && 'common-grouped-dropdown_menu--top',
        isBorder && 'common-grouped-dropdown_menu--border',
      )}>
      {!hasOptions ? (
        <div className='common-grouped-dropdown_no-options common-grouped-dropdown_item' role='status'>
          {t('noOptionsFound')}
        </div>
      ) : (
        <div className='common-grouped-dropdown_groups'>
          {filteredGroups.map((group, groupIndex) => (
            <div key={`${String(group.groupLabel ?? '')}-${groupIndex}`} className='common-grouped-dropdown_group'>
              {group.groupLabel != null && group.groupLabel !== '' && (
                <div className='common-grouped-dropdown_group-header'>{group.groupLabel}</div>
              )}
              <ul className='common-grouped-dropdown_options' role='group' aria-label={group.groupLabel ?? undefined}>
                {group.options.map((opt) => (
                  <OptionItem
                    key={opt.value}
                    option={opt}
                    searchQuery={searchQuery}
                    withIcons={withIcons}
                    isEmojiIcons={isEmojiIcons}
                    isHighlighted={opt === highlightedOption}
                    onSelect={onSelectOption}
                    listboxId={listboxId}
                    emptyLabel={t('empty')}
                  />
                ))}
              </ul>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default memo(DropdownMenu);
